var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknownErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 192,
    width: 192,
    viewBox: "0 0 96 96",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24,
    x: 0,
    y: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 80.000768,74.000365 a 7.9894501,7.9894501 0 0 0 7.959881,-7.999614 l 0.03973,-44.000192 A 8.0236405,8.0236405 0 0 0 80.000768,14.00002 H 16.000154 a 8.0236405,8.0236405 0 0 0 -7.9996151,7.999615 v 44.001116 a 8.0236405,8.0236405 0 0 0 7.9996151,7.999614 H -1.4999998e-8 A 8.0236405,8.0236405 0 0 0 7.9996148,81.99998 H 88.000383 A 8.0236405,8.0236405 0 0 0 96,74.000365 Z M 16.000154,21.999635 H 80.000768 V 66.000751 H 16.000154 Z m 32.000307,55.998228 a 4.0002694,4.0002694 0 1 1 4.00027,-4.00027 4.0113582,4.0113582 0 0 1 -4.00027,4.003042 z",
    fill: "#1d1d1d",
    fillOpacity: 1,
    strokeWidth: 0.924063
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 48,46.840964 c -5.91022,0 -10.932638,3.703399 -12.961898,8.878012 H 60.961897 C 58.932637,50.544363 53.910219,46.840964 48,46.840964 Z m -10.602884,-3.804862 2.68877,-2.68877 2.688769,2.68877 2.68877,-2.68877 -2.68877,-2.688769 2.68877,-2.68877 -2.68877,-2.688769 -2.688769,2.688769 -2.68877,-2.688769 -2.688769,2.688769 2.688769,2.68877 -2.688769,2.688769 z m 21.205767,-10.755078 -2.68877,2.688769 -2.688769,-2.688769 -2.68877,2.688769 2.68877,2.68877 -2.68877,2.688769 2.68877,2.68877 2.688769,-2.68877 2.68877,2.68877 2.688769,-2.68877 -2.688769,-2.688769 2.688769,-2.68877 z",
    fill: "#d9240f",
    fillOpacity: 1,
    strokeWidth: 2.53657
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownErrorIcon);
export default __webpack_public_path__ + "static/media/Unknown_Error_icon.f7f4dd31fc28762260cca3f9c6f00017.svg";
export { ForwardRef as ReactComponent };